import React from 'react';
import { Card, Row, Col } from 'antd';
import DonutChart from './DonutChart';

const PALETTE = {
  green: ['#10b981', '#059669'],
  amber: ['#f59e0b', '#d97706'],
  rose: ['#f43f5e', '#e11d48'],
  cyan: ['#06b6d4', '#0891b2'],
  blue: ['#3b82f6', '#2563eb'],
};

const WebsiteSnippetHealthCard = ({ websites = [], snippets = [] }) => {
  // Calculate status counts
  const statusCounts = websites.reduce((acc, w) => {
    const st = w.status || 'active';
    acc[st] = (acc[st] || 0) + 1;
    return acc;
  }, {});

  return (
    <Card title="Website & Snippet Health" style={{ borderRadius: 16 }}>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <div style={{ textAlign: 'center', marginBottom: 8, fontSize: 12, fontWeight: 400, color: '#475569' }}>
            Website Status
          </div>
          <DonutChart
            data={[
              { label: 'Active', value: statusCounts.active || 0, color: PALETTE.green[1] },
              { label: 'Inactive', value: statusCounts.inactive || 0, color: PALETTE.amber[1] },
              { label: 'Suspended', value: statusCounts.suspended || 0, color: PALETTE.rose[1] },
              { label: 'Pending', value: statusCounts.pending || 0, color: PALETTE.cyan[1] },
            ].filter(d => d.value > 0)}
            size={130}
            showLabels={false}
          />
        </Col>
        <Col span={12}>
          <div style={{ textAlign: 'center', marginBottom: 8, fontSize: 12, fontWeight: 400, color: '#475569' }}>
            Snippet Status
          </div>
          <DonutChart
            data={[
              { label: 'Active', value: snippets.filter(s => s.is_active || s.meta?.status === 'active').length, color: PALETTE.blue[1] },
              { label: 'Inactive', value: snippets.filter(s => !s.is_active && s.meta?.status !== 'active').length, color: '#e2e8f0' },
            ].filter(d => d.value > 0)}
            size={130}
            showLabels={false}
          />
        </Col>
      </Row>
      <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, textAlign: 'center' }}>
        {[
          { label: 'Active', val: statusCounts.active || 0, color: PALETTE.green[1] },
          { label: 'Inactive', val: statusCounts.inactive || 0, color: PALETTE.amber[1] },
          { label: 'Suspended', val: statusCounts.suspended || 0, color: PALETTE.rose[1] },
          { label: 'Pending', val: statusCounts.pending || 0, color: PALETTE.cyan[1] },
        ].map(s => (
          <div key={s.label} style={{ padding: '10px 4px', borderRadius: 10, background: `${s.color}11`, border: `1px solid ${s.color}33` }}>
            <div style={{ fontSize: 18, fontWeight: 400, color: s.color }}>{s.val}</div>
            <div style={{ fontSize: 10, color: '#64748b', marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default WebsiteSnippetHealthCard;
